import React from 'react';
import { AdapterProps } from '../types';
import { Controller, useFormContext } from 'react-hook-form';
import { useFormError } from '../utils';
import get from 'lodash/get';
import FormControl from '../../FormControl/FormControl';
import InputLabel from '../../InputLabel/InputLabel';
import MaskedTextField from '../../MaskedTextField/MaskedTextField';

export type Props = AdapterProps['text-masked'];

const MaskedTextAdapter = (props: Props) => {
  const {
    label,
    name,
    rules,
    disabled,
    mask,
    imaskOptions,
    normalize,
    placeholderChar,
    defaultValue,
  } = props;
  const { control, formState } = useFormContext();
  const error = useFormError(get(formState.errors, name));

  if (!mask && !imaskOptions) {
    throw new Error(
      'MaskedText requires "mask" or "imaskOptions" prop to be set.',
    );
  }

  const normalizeValue = (value: string) => {
    if (normalize && ['number', 'decimal'].includes(normalize)) {
      const asDecimal = String(value).replace(/[^\d\s]/g, '');

      if (normalize === 'number') {
        return Number(asDecimal);
      }

      return asDecimal;
    }

    return value;
  };

  return (
    <FormControl error={!!error} disabled={disabled}>
      {label && <InputLabel>{label}</InputLabel>}
      <Controller
        name={name}
        rules={rules}
        control={control}
        disabled={disabled}
        defaultValue={defaultValue}
        render={({ field: { onChange, value } }) => {
          return (
            <MaskedTextField
              error={error}
              placeholderChar={placeholderChar}
              name={name}
              mask={mask}
              imaskOptions={imaskOptions}
              onChange={(event, value) => {
                onChange({
                  target: {
                    value: normalizeValue(value),
                  },
                });
              }}
              value={value}
            />
          );
        }}
      />
    </FormControl>
  );
};

export default MaskedTextAdapter;
